import React from 'react';
import { useTranslation } from 'react-i18next';
import { HeaderTemplate, Stepper, TitleHeader } from 'web-library';
import AccessArrangementRequest from '../../modules/accessArrangment/components/candidate/AccessArrangementRequest/AccessArrangementRequest';

interface AccessArrangementRequestProps {
  routeSteps: { label: string }[];
  amendment?: boolean;
  activeStep: number;
}

const AccessArrangementRequestPage = ({
  routeSteps,
  amendment,
  activeStep,
}: AccessArrangementRequestProps) => {
  const { t } = useTranslation();

  return (
    <>
      <TitleHeader
        title={t('accessArrangement->>AccessArrangementRoute.ApplyforAccessArrangements')}
      />
      <HeaderTemplate>
        <Stepper activeStep={activeStep} steps={routeSteps} />
      </HeaderTemplate>
      <AccessArrangementRequest amendment={amendment} />
    </>
  );
};

export default AccessArrangementRequestPage;
